import { createContext, useContext } from 'react'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RainbowKitProvider, getDefaultConfig } from '@rainbow-me/rainbowkit'
import { WALLET_CHAINS } from '../constants/networks'

const OnChainContext = createContext(null)

export const supportedChains = WALLET_CHAINS

const queryClient = new QueryClient()

const wagmiConfig = getDefaultConfig({
  appName: 'mimic-env-tool',
  projectId: process.env.REACT_APP_WC_CLOUD_PROJECT_ID,
  chains: supportedChains,
  ssr: false,
  enableWalletConnect: true,
  enableInjected: true,
  enableEIP6963: true,
  enableCoinbase: true,
})

export const OnChainProvider = ({ children }) => {
  return (
    <OnChainContext.Provider value={{ wagmiConfig }}>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider coolMode>{children}</RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </OnChainContext.Provider>
  )
}

export const useOnChainConfig = () => useContext(OnChainContext)
